import React from "react";
import DeviceRow from "./DeviceRow";

export default function DeviceRowCategory({ device, filter, ...props }) {
  // Apply filter logic
  // if (filter && !device.alias.toLowerCase().includes(filter.toLowerCase())) {
  //   return null;
  // }

  return <DeviceRow device={device} {...props} />;
}
